export const eligibilityPage = {
  heading: 'eligibility-page-heading',
  sectionHeading: 'eligibility-section-heading',
  sectionBody: 'eligibility-section-body',
  modal: 'eligibility-modal',
  modalParagraph: 'eligibility-modal-paragraph',
  modalLink: 'eligibility-modal-link',
  button: 'eligibility-download-guide-button'
};
